// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"814358f2","627":"c461ccab","653":"d071c3c5","738":"adac5289","923":"ca7ce4c4"}[chunkId] + ".chunk.js";
};